import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, {}=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Proactively clear any legacy token cached by earlier builds — auth is
    // now purely cookie-based, and the cookie is session-only for privacy.
    localStorage.removeItem("hygenix_token");
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Best-effort logout; even if the server call fails we still clear local state.
      console.debug("logout call failed (safe to ignore):", err?.message);
    }
    // Clear any legacy token cache from earlier builds (safe no-op after this release).
    localStorage.removeItem("hygenix_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
